import { useEffect, useRef } from "react";

export const CustomCursor = () => {
  const starRef = useRef(null);

  useEffect(() => {
    const isTouch = window.matchMedia("(hover: none), (pointer: coarse)").matches;
    if (isTouch || !starRef.current) return;

    document.body.classList.add("has-custom-cursor");
    let lastSpawn = 0;

    const spawnTrail = (x, y) => {
      const dot = document.createElement("div");
      dot.className = "custom-cursor-trail";
      dot.style.left = `${x}px`;
      dot.style.top = `${y}px`;
      const layer = document.getElementById("fx-layer") || document.body;
      layer.appendChild(dot);
      if (window.gsap) {
        window.gsap.to(dot, {
          opacity: 0,
          scale: 0.3,
          duration: 0.6,
          ease: "power1.out",
          onComplete: () => dot.remove(),
        });
      } else {
        setTimeout(() => dot.remove(), 600);
      }
    };

    const handleMove = (e) => {
      if (starRef.current) {
        starRef.current.style.transform = `translate(${e.clientX}px, ${e.clientY}px) translate(-50%, -50%)`;
      }
      const now = performance.now();
      if (now - lastSpawn > 60) {
        lastSpawn = now;
        spawnTrail(e.clientX, e.clientY);
      }
    };

    window.addEventListener("mousemove", handleMove);
    return () => {
      window.removeEventListener("mousemove", handleMove);
      document.body.classList.remove("has-custom-cursor");
    };
  }, []);

  if (typeof window !== "undefined" && window.matchMedia("(hover: none), (pointer: coarse)").matches) {
    return null;
  }

  return (
    <div ref={starRef} data-testid="custom-cursor" className="custom-cursor-star">
      <svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor">
        <path d="M12 0 L14.5 9.5 L24 12 L14.5 14.5 L12 24 L9.5 14.5 L0 12 L9.5 9.5 Z" />
      </svg>
    </div>
  );
};
